import { FCM_DM_PROFILE_REDESIGN, FCM_DM_PROFILE_RESPONSIVENESS_SCORE_CONFIG } from '@change-corgi/fcm/configs';

import { createFcmContext } from 'src/app/shared/contexts/fcm';
import type { LoadedStateData } from 'src/app/shared/utils/async';

export const {
	FcmContext: DecisionMakerProfilePageFcmContext,
	FcmProvider: DecisionMakerProfilePageFcmContextProvider,
	useFcm: useDecisionMakerProfilePageFcm,
	useAsyncFcm: useAsyncDecisionMakerProfilePageFcm,
	prefetchFcm: prefetchDecisionMakerProfilePageFcm,
} = createFcmContext({
	name: 'DecisionMakerProfilePageFcmContext',
	dataProperty: 'pageFcm',
	configs: {
		dmProfileRedesign: FCM_DM_PROFILE_REDESIGN,
		dmResponsivenessScoreConfig: FCM_DM_PROFILE_RESPONSIVENESS_SCORE_CONFIG,
	},
	prefetch: true,
});

export type DecisionMakerProfilePageFcmState = ReturnType<typeof useAsyncDecisionMakerProfilePageFcm>;
export type DecisionMakerProfilePageFcm = LoadedStateData<DecisionMakerProfilePageFcmState>;
